import React, {Component} from "react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import Refresh from '@material-ui/icons/Refresh';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {
    AccountCircle, Brush, KeyboardArrowLeft, KeyboardArrowRight, LockOpen, Print,
    Today, ZoomIn, ZoomOut, ExitToApp
} from "@material-ui/icons"
import {withStyles} from "@material-ui/core/styles";
import C from "../Constants";
import {Hidden, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Popover, Tooltip} from "@material-ui/core";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment/moment";


const styles = theme => ({
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    fillSpaceMiddle: {
        flex: 1,
    },
    title: {
        maxHeight: "48px",
        overflow: "hidden",
        paddingLeft: theme.spacing.unit * 2,
    },
    popover: {
        minWidth: theme.spacing.unit * 30,
        width: "100%",
        height: "100%",
    },
    primary: {
        color: theme.palette.secondary,
    }
});

class PrayerAppbar extends Component {

    state = {
        brushDropdownOpen: false,
        selectGroupDialogOpen: false,
        brushMode: null,
    };

    render() {
        const {classes} = this.props;
        const title = this.props.title !== undefined && this.props.title != null && this.props.title != "" && this.groupExisting() ? this.props.title : "24-7 Ort...";
        return <AppBar position="static"> <Toolbar id="appbarVisibility">
            <IconButton className={this.props.menuButton} color="inherit" aria-label="Menu"
                        onClick={this.toggleLeftDrawer}>
                <MenuIcon/>
            </IconButton>
            <Typography onClick={this.changeValueFixed('selectGroupDialogOpen', true)} ref="title"
                        variant="title" color="inherit" className={classes.title}>
                {title}</Typography>
            {this.selectGroupDialog()}
            <span className={classes.fillSpaceMiddle}/>
            {this.dateNavigation()}
            {this.brushQuickMode()}
            {this.printingIndicator()}
            {this.logoutUserButton()}
            {this.formatHourSpacingButton()}
        </Toolbar></AppBar>;
    }

    selectGroupDialog() {
        const {classes} = this.props;
        const stillLoadingIndicator = this.props.groupNames != null && this.props.groupNames.length > 0 ?
            <ListItem onClick={this.groupNameChanges("")} button key={"nothing"}>
                <ListItemText primary=""/>
            </ListItem> :
            <ListItem button onClick={this.groupNameChanges("")}>
                <ListItemIcon><Refresh/></ListItemIcon>
                <ListItemText primary="ladet gerade..."/>
            </ListItem>;

        return this.props.anonymousGroup === true ? null: <Popover open={this.state.selectGroupDialogOpen}
                        onClose={this.changeValueFixed('selectGroupDialogOpen', !this.state.selectGroupDialogOpen)}>
            <List className={classes.popover}>
                <Scrollbars autoHeight autoHeightMin={400}>
                    {stillLoadingIndicator}
                    {this.props.groupNames.map(groupName => {
                        const color = groupName == this.state.groupName ? classes.primary : "";
                        return <ListItem onClick={this.groupNameChanges(groupName)} button className={color}
                                         key={groupName}><ListItemText primary={groupName}/></ListItem>;
                    })}
                </Scrollbars>
            </List>
        </Popover>;
    }

    formatHourSpacingButton() {
        if (!this.props.loggedIn) return null;
        return <Tooltip title="Formatierng ändern" placement="bottom">
            <IconButton color="inherit" onClick={this.toggleDensity}>{this.props.hoursAreDense ? <ZoomIn/> : <ZoomOut/>}</IconButton></Tooltip>;
    }

    logoutUserButton() {
        if (this.props.loginData == null || !this.props.loginData.isGroupUser || this.props.autoLogin) return null;
        return <Tooltip title="ausloggen" placement="bottom">
            <IconButton color="inherit" onClick={this.logoutUser}>{this.props.loginData.isGroupAdmin ? <AccountCircle/> :
                <ExitToApp/>}</IconButton></Tooltip>
    }

    dateNavigation() {
        if (!this.groupExisting()) return null;
        return [
            this.props.loggedIn ? <Hidden xsDown key={"left"}>
                <Tooltip title="Datum weiter links" placement="bottom">
                    <IconButton color="inherit"
                                onClick={this.dateLeft}><KeyboardArrowLeft/></IconButton></Tooltip></Hidden> : null,
            this.props.loggedIn ? <Hidden xsDown key={"right"}>
                <Tooltip title="Datum weiter rechts" placement="bottom">
                    <IconButton color="inherit"
                                onClick={this.dateRight}><KeyboardArrowRight/></IconButton></Tooltip></Hidden> : null,
            <Tooltip title="zu heute springen" placement="bottom" key={"today"}>
                <IconButton color="inherit" onClick={this.goToToday}><Today/></IconButton></Tooltip>,
        ];
    }

    brushAnchor = null;

    brushQuickMode() {
        if (this.props.loginData == null || !this.props.loginData.isGroupAdmin || !this.props.loggedIn) return null;
        let color = "rgba(0, 0, 0, 0)";
        if (this.props.brushMode === -1) {
            color = "black";
        } else {
            let hourType = null;
            if (this.props.hourTypes != null){
                this.props.hourTypes.find((hourType) => hourType.hourType === this.props.brushMode);
            }
            if (hourType != null) {
                color = hourType.color;
            }
        }
        return [<Tooltip key="button" title="Quickmode um Stunden einzutragen" placement="bottom">
            <IconButton style={{backgroundColor: color}} color="inherit"
                        onClick={this.brushOpen(true)}><Brush/></IconButton></Tooltip>,
            <Menu key="menu" onClose={this.brushOpen(false)} open={this.state.brushDropdownOpen}
                  anchorEl={this.state.brushAnchor}>
                <MenuItem button onClick={this.changeBrushMode(null)}>nicht aktiv</MenuItem>
                <MenuItem button style={{backgroundColor: "black", color: "white"}} onClick={this.changeBrushMode(-1, "white")}>löschen</MenuItem>
                {this.props.hourTypes != null ? this.props.hourTypes.map(hourType => {
                    return <MenuItem style={{backgroundColor: hourType.color}} key={hourType.hourType}
                                     onClick={this.changeBrushMode(hourType.hourType)}>{C.hourTypeIdToNameMapping[hourType.hourType]}</MenuItem>;
                }) : null}
            </Menu>
        ];
    }

    printingIndicator() {
        if (!this.props.isPrinting || !this.props.loggedIn) return null;
        return <Tooltip title="Farben für Drucker angepasst" placement="bottom">
            <IconButton onClick={this.print} color="inherit"><Print/></IconButton></Tooltip>
    }

    changeValueFixed = (key, value) => () => this.setState({[key]: value});
    changeValue = key => value => this.setState({[key]: value});
    changeValueByEvent = key => event => this.setState({[key]: event.target.value});
    groupNameChanges = (value) => () => {
        this.props.app.serverCommunication.serverLogoutFromServer();
        this.props.app.changeGroupName(value);
        this.setState({selectGroupDialogOpen: false});
    };
    brushOpen = (active) => (event) => this.setState({
        brushDropdownOpen: active,
        brushAnchor: event != null ? event.currentTarget : null
    });
    dateLeft = () => this.props.app.changeSelectedDate(this.props.selectedDate.clone().subtract('day', 3));
    dateRight = () => this.props.app.changeSelectedDate(this.props.selectedDate.clone().add('day', 3));
    toggleLeftDrawer = () => this.props.app.toggleOptionsDrawer();
    toggleDensity = () => this.props.app.toggleDensity();
    groupExisting = () => this.props.groupNames.indexOf(this.props.groupData.groupName) >= 0;
    goToToday = () => {
        this.props.app.changeSelectedDate(moment().startOf('day'));
        this.props.app.changeDisplayMonth(moment().startOf('month').startOf('day'))
    };
    changeBrushMode = (mode) => () => {
        this.setState({brushDropdownOpen: false});
        this.props.app.setBrushMode(mode);
    };
    print = () => window.print();
    logoutUser = () => {
        this.props.app.serverCommunication.serverLogoutFromServer();
    };
}


PrayerAppbar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PrayerAppbar);
